import React, { useState } from 'react';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import { useParams } from 'react-router-dom';
import GenericError from 'src/component/GenericError';
import useGetCourse from 'src/hook/CourseHook';
import Course from 'src/model/Course';
import Box from '@mui/material/Box';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import CourseChapterAccordion from 'src/component/CourseChapterAccordion';
import CourseChapter from 'src/model/CourseChapter';
import useListCourseChapter from 'src/hook/CourseChapterHook';

export default function CoursePage() {
  const { courseId } = useParams();
  const [errorState, setError] = useState(false);
  const courseState: Course = useGetCourse(setError, courseId);
  const courseChaptersState: Array<CourseChapter> = useListCourseChapter(setError, courseId);

  const courseChapterAccordions = courseChaptersState.map((courseChapter) => (
    <CourseChapterAccordion courseChapter={courseChapter} key={courseChapter.courseChapterId} />
  ));
  // Use require until app becomes large enough to load images from cdn.
  // eslint-disable-next-line global-require, import/no-dynamic-require
  const courseImageSrc = require(`src/${courseState.image}`);

  if (errorState) {
    return <GenericError errorMessage="" />;
  }

  return (
    <Box
      sx={{
        mt: 5,
      }}
    >
      <Container>
        <Grid container>
          <Grid item xs={12}>
            <CardMedia component="img" src={courseImageSrc} alt="course picture" />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h5" color="text.secondary" paragraph>
              {courseState.description}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            {courseChapterAccordions}
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
